export const TAX_RATES = [
  { value: 20.0, label: "20 %" },
  { value: 10.0, label: "10 %" },
  { value: 8.5, label: "8,5 %" },
  { value: 5.5, label: "5,5 %" },
  { value: 2.1, label: "2,1 %" },
  { value: 1.75, label: "1,75 %" },
  { value: 1.05, label: "1,05 %" },
  { value: 0, label: "0 %" },
] as const;

export const DEFAULT_TAX_RATE = 20.0;

export function formatPrice(value: number, currency = "EUR"): string {
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency }).format(value);
}

export function formatNum(v: number): string {
  return (Math.round(v * 100) / 100).toString();
}

export function htToTtc(ht: number, taxRate: number): number {
  return Math.round(ht * (1 + taxRate / 100) * 100) / 100;
}

export function ttcToHt(ttc: number, taxRate: number): number {
  return Math.round((ttc / (1 + taxRate / 100)) * 100) / 100;
}
